import React, { useState } from 'react';
import styles from './Login.module.scss';
import LoginVideo from 'component/atom/forms/login-components/video/LoginVideo';

import LoginForm from './form/login-form/LoginForm';
import ResetPasswordForm from './form/reset-password/ResetPasswordForm';

const Login = () => {
  const [view, setView] = useState('login');

  return (
    <div className={styles.login}>
      <div className={styles.left}>
        <LoginVideo />
      </div>

      <div className={styles.right}>
        {view === 'login' ? (
          <LoginForm onForgotPassword={() => setView('reset')} />
        ) : (
          <ResetPasswordForm onBackToLogin={() => setView('login')} />
        )}
      </div>
    </div>
  );
};

export default Login;
